module.exports = __webpack_public_path__ + "img/2.8d47dbe5.jpg";